import { calculatePublicPath } from "canopy-sofe-extensions";

if (__webpack_public_path__ !== undefined) {
  __webpack_public_path__ = calculatePublicPath("primary-navbar");
}
